import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Building2, Hash } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || '';

const Footer = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/legal/platform-info`)
      .then(res => res.ok ? res.json() : null)
      .then(data => { if (data) setInfo(data); })
      .catch(() => {});
  }, []);

  const platformName   = info?.platform_name    || 'DalSud';
  const legalEntity    = info?.legal_entity_name || null;
  const legalAddress   = info?.legal_address     || null;
  const vatNumber      = info?.vat_number        || null;
  const contactEmail   = info?.legal_email       || info?.support_email || null;

  return (
    <footer className="bg-[#1A1A1A] text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">

          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block">
              <span className="font-heading text-2xl font-bold text-white">{platformName}</span>
            </Link>
            <p className="mt-4 text-gray-400 text-sm leading-relaxed">
              Il marketplace che connette i migliori produttori del Sud Italia direttamente con te.
              Qualità, autenticità e tradizione in ogni prodotto.
            </p>
          </div>

          {/* Esplora */}
          <div>
            <h3 className="font-semibold text-white mb-4">Esplora</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/prodotti" className="text-gray-400 hover:text-white transition-colors">
                  Tutti i Prodotti
                </Link>
              </li>
              <li>
                <Link to="/produttori" className="text-gray-400 hover:text-white transition-colors">
                  I Nostri Produttori
                </Link>
              </li>
              <li>
                <Link to="/regioni" className="text-gray-400 hover:text-white transition-colors">
                  Regioni
                </Link>
              </li>
              <li>
                <Link to="/diventa-produttore" className="text-gray-400 hover:text-white transition-colors">
                  Diventa Produttore
                </Link>
              </li>
            </ul>
          </div>

          {/* Legale */}
          <div>
            <h3 className="font-semibold text-white mb-4">Legale</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/legal/termini-condizioni" className="text-gray-400 hover:text-white transition-colors">
                  Termini e Condizioni
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/cookie-policy" className="text-gray-400 hover:text-white transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/resi-rimborsi" className="text-gray-400 hover:text-white transition-colors">
                  Politica Resi e Rimborsi
                </Link>
              </li>
            </ul>
          </div>

          {/* Contatti & Dati societari */}
          <div>
            <h3 className="font-semibold text-white mb-4">Contatti</h3>
            <ul className="space-y-3 text-sm">
              {legalAddress && (
                <li className="flex items-start gap-2 text-gray-400">
                  <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <span>{legalAddress}</span>
                </li>
              )}
              {contactEmail && (
                <li className="flex items-center gap-2 text-gray-400">
                  <Mail className="w-4 h-4 flex-shrink-0" />
                  <a href={`mailto:${contactEmail}`} className="hover:text-white transition-colors">
                    {contactEmail}
                  </a>
                </li>
              )}
              {legalEntity && (
                <li className="flex items-start gap-2 text-gray-400">
                  <Building2 className="w-4 h-4 flex-shrink-0 mt-0.5" />
                  <span>{legalEntity}</span>
                </li>
              )}
              {vatNumber && (
                <li className="flex items-center gap-2 text-gray-400">
                  <Hash className="w-4 h-4 flex-shrink-0" />
                  <span>P.IVA {vatNumber}</span>
                </li>
              )}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center md:text-left">
              © {new Date().getFullYear()} {platformName}
              {legalEntity && <> · {legalEntity}</>}
              {vatNumber && <> · P.IVA {vatNumber}</>}
              {' '}· Tutti i diritti riservati.
            </p>
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
              <Link to="/legal/privacy-policy" className="text-gray-500 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/legal/termini-condizioni" className="text-gray-500 hover:text-white transition-colors">
                Termini di Servizio
              </Link>
              <Link to="/legal/cookie-policy" className="text-gray-500 hover:text-white transition-colors">
                Cookie Policy
              </Link>
              <Link to="/legal/resi-rimborsi" className="text-gray-500 hover:text-white transition-colors">
                Resi e Rimborsi
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
